module.exports = __webpack_public_path__ + "img/24.80c2daa6.jpg";